import { GAME_W, GAME_H, CURTAIN_CLOSE_DELAY, CURTAIN_OPEN_DELAY, CURTAIN_WAIT_FRAMES } from "./data";
import { dt } from "lib/loop";

export const curtains = {
  _percent: 1,
  _delay: 0,
  _dir: 0,
  _blindTime: 0,
  _waitTime: -1,
  _callback: null as (() => void) | null,
  active: false,
  visible: false,

  open(delay: number = CURTAIN_OPEN_DELAY): void {
    this._dir = 1;
    this._delay = delay;
    this._blindTime = delay;
    this.active = true;
    this.visible = true;
  },

  close(delay: number = CURTAIN_CLOSE_DELAY, callback?: () => void): void {
    this._dir = 0;
    this._delay = delay;
    this._blindTime = delay;
    this._callback = callback ?? null;
    this.active = true;
    this.visible = true;
  },

  update(): void {
    if (!this.active) return;
    if (this._delay === 0) {
      this._percent = this._dir === 1 ? 1 : 0;
      if (this._dir === 0) {
        this._waitTime = CURTAIN_WAIT_FRAMES;
      } else {
        this.active = false;
        this.visible = false;
        this._percent = 0;
      }
      return;
    }

    if (this._waitTime >= 0) {
      this._waitTime -= dt;
      if (this._waitTime < 0) {
        this._waitTime = -1;
        if (this._callback) {
          this._callback();
          this._callback = null;
        }
        this.open();
      }
      return;
    }

    this._blindTime -= dt;
    let percent: number;
    if (this._dir === 1) {
      percent = 1 - this._blindTime / this._delay;
    } else {
      percent = this._blindTime / this._delay;
    }
    if (percent < 0) percent = 0;
    if (percent > 1) percent = 1;

    this._percent = percent;

    if (this._blindTime <= 0) {
      if (this._dir === 0) {
        this._waitTime = CURTAIN_WAIT_FRAMES;
      } else {
        this.active = false;
        this.visible = false;
        this._percent = 0;
      }
    }
  },

  render(ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D): void {
    if (!this.visible) return;
    const holeSize = GAME_W * this._percent;
    const halfH = (GAME_H - holeSize) * 0.5;
    const holeTop = halfH | 0;
    const holeBottom = (GAME_H - halfH) | 0;
    const halfW = (GAME_W - holeSize) * 0.5;
    const leftEdge = halfW | 0;
    const rightEdge = (GAME_W - halfW) | 0;

    ctx.fillStyle = "#000000";
    ctx.fillRect(0, 0, GAME_W, holeTop);
    ctx.fillRect(0, holeBottom, GAME_W, GAME_H - holeBottom);
    ctx.fillRect(0, holeTop, leftEdge, holeBottom - holeTop);
    ctx.fillRect(rightEdge, holeTop, GAME_W - rightEdge, holeBottom - holeTop);
  },
};
